import React from 'react';
import { Skeleton, Space } from 'antd';

export const ProfileSkeleton = () => {
  return (
    <div className="w-full h-full">
      <Space>
        <Skeleton.Image active />
        <Skeleton.Button active />
        <Skeleton.Button active />
      </Space>
      <div className={'flex gap-5 mt-4'}>
        <Skeleton.Input active />
        <Skeleton.Input active />
      </div>
      <div className={'flex gap-5 mt-4'}>
        <Skeleton.Input active />
        <Skeleton.Input active />
      </div>
      <div className={'flex mt-4'}>
        <Skeleton.Input active />
      </div>
      <div className={'flex mt-4'}>
        <Skeleton.Button active />
      </div>
    </div>
  );
};
